const flatRoofing = [
  {
    question: "What are flat roofs made of?",
    answer:
      "Flat roofs<IN_CITY_ZIP> are typically built with TPO, modified bitumen, or torch-down membranes. These materials offer excellent waterproofing, UV resistance, and long-term durability for both residential and commercial properties.",
  },
  {
    question: "How long does a flat roof last?",
    answer:
      "With proper installation and maintenance, flat roofs<IN_CITY_ZIP> can last 20 to 30 years. TPO and modified bitumen systems often provide longer lifespan than older materials like built-up roofing.",
  },
  {
    question: "Do I need a permit to install or replace a flat roof?",
    answer:
      "Yes. Roofing projects<IN_CITY_ZIP> require city permits and inspections to ensure safety and compliance. Modern Build handles all engineering, permitting, and final sign-offs for you.",
  },
  {
    question: "How long does it take to install a flat roof?",
    answer:
      "Most flat roof installations<IN_CITY_ZIP> take 3 to 7 days depending on size, material, and any underlying repairs needed. We'll give you a detailed schedule during your estimate.",
  },
  {
    question: "Are flat roofs suitable for hot climates like California?",
    answer:
      "Yes. Flat roofs<IN_CITY_ZIP> can be extremely efficient in hot climates when paired with cool-roof coatings or white TPO membranes, which reflect sunlight and reduce cooling costs.",
  },
  {
    question: "What types of flat roof systems do you install?",
    answer:
      "We offer TPO, torch-down, and modified bitumen flat roofing systems<IN_CITY_ZIP>. Each type has unique benefits for waterproofing, energy efficiency, and budget — we’ll help you choose the best option for your property.",
  },
  {
    question: "Can a flat roof be installed over an existing roof?",
    answer:
      "In some cases, yes. If your existing roof<IN_CITY_ZIP> is structurally sound and meets code, we may be able to install a new flat roof as an overlay. Our team inspects and advises the safest and most cost-effective solution.",
  },
  {
    question: "How much does a flat roof cost?",
    answer:
      "Flat roof installations<IN_CITY_ZIP> typically range from $8,000 to $20,000+, depending on material, size, insulation, and required prep. We provide clear, upfront pricing with no hidden fees.",
  },
  {
    question: "Are warranties available on flat roof systems?",
    answer:
      "Yes. All of our flat roof installations<IN_CITY_ZIP> come with manufacturer warranties on the membrane and components, as well as a labor warranty from Modern Build for added peace of mind.",
  },
  {
    question: "Can flat roofs support solar panels or rooftop decks?",
    answer:
      "Yes. Many homeowners<IN_CITY_ZIP> install solar panels or rooftop decks on flat roofs. We ensure structural integrity, proper flashing, and drainage to support these upgrades safely.",
  },
];

export default flatRoofing;
